import React from 'react';
import { Empty, Space, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Wrapper } from './styled';
import PermissionButton from '@src/emp-3.0/components/PermissionButton';
import { useIsPatternMode } from '../../utils';

interface EmptyStateProps {
  isLoading?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({ isLoading }) => {
  const navigate = useNavigate();
  const { patternCreatePermission } = useIsPatternMode();

  const handleCreateFlow = () => {
    navigate('/workflow/flow/new');
  };

  const handleCreatePattern = () => {
    navigate('/workflow/pattern/new');
  };

  const handleCreateMetric = () => {
    navigate('/workflow/metric/new');
  };

  return (
    <Wrapper>
      <Spin spinning={isLoading} style={{ height: '100%' }}>
        {!isLoading && (
          <>
            <Empty
              description="You haven’t created any Flows or Metrics yet."
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
            <Space style={{ marginTop: 16 }}>
              <PermissionButton
                styleType="styled"
                type="secondary"
                onClick={handleCreateFlow}
                lackPermissionToolTip="Non-Admin Permission, go to management for details"
              >
                Create Flow
              </PermissionButton>
              {patternCreatePermission && (
                <PermissionButton
                  styleType="styled"
                  type="secondary"
                  onClick={handleCreatePattern}
                  lackPermissionToolTip="Non-Admin Permission, go to management for details"
                >
                  Create Pattern (Internal Only)
                </PermissionButton>
              )}
              <PermissionButton
                styleType="styled"
                type="secondary"
                onClick={handleCreateMetric}
                lackPermissionToolTip="Non-Admin Permission, go to management for details"
              >
                Create Individual Metric
              </PermissionButton>
            </Space>
          </>
        )}
      </Spin>
    </Wrapper>
  );
};

export default EmptyState;
